import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class LocalDevelopmentResetService {
  public async clearBrowserData(): Promise<void> {
    localStorage.clear();
    sessionStorage.clear();
    this.clearCookies();

    await Promise.all([
      this.clearCacheStorage(),
      this.unregisterServiceWorkers(),
      this.clearIndexedDb(),
    ]);
  }

  private clearCookies(): void {
    const cookieNames = document.cookie
      .split(";")
      .map((cookie) => cookie.split("=")[0].trim())
      .filter((name) => !!name);
    const pathParts = window.location.pathname.split("/").filter((part) => !!part);
    const paths = ["/"];
    let currentPath = "";
    pathParts.forEach((part) => {
      currentPath += `/${part}`;
      paths.push(currentPath);
    });

    cookieNames.forEach((name) => {
      paths.forEach((path) => {
        document.cookie = `${name}=; Max-Age=0; path=${path}`;
        document.cookie = `${name}=; Max-Age=0; path=${path}; domain=nogosh.local`;
        document.cookie = `${name}=; Max-Age=0; path=${path}; domain=.nogosh.local`;
      });
    });
  }

  private async clearCacheStorage(): Promise<void> {
    if (!("caches" in window)) {
      return;
    }
    try {
      const names = await window.caches.keys();
      await Promise.all(names.map((name) => window.caches.delete(name)));
    } catch (_) {
    }
  }

  private async unregisterServiceWorkers(): Promise<void> {
    if (!("serviceWorker" in navigator)) {
      return;
    }
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    } catch (_) {
    }
  }

  private async clearIndexedDb(): Promise<void> {
    const indexedDbWithListing = indexedDB as IDBFactory & {
      databases?: () => Promise<Array<{ name?: string }>>;
    };
    if (!indexedDbWithListing || typeof indexedDbWithListing.databases !== "function") {
      return;
    }
    try {
      const databases = await indexedDbWithListing.databases();
      await Promise.all(databases
        .map((database) => database.name)
        .filter((name): name is string => !!name)
        .map((name) => this.deleteIndexedDb(name)));
    } catch (_) {
    }
  }

  private deleteIndexedDb(name: string): Promise<void> {
    return new Promise((resolve) => {
      const request = indexedDB.deleteDatabase(name);
      const timeout = window.setTimeout(resolve, 750);
      const finish = () => {
        window.clearTimeout(timeout);
        resolve();
      };
      request.onsuccess = finish;
      request.onerror = finish;
      request.onblocked = finish;
    });
  }
}
